import logo from '../assets/images/logo-nobg.png';

export default function LogoToken(props: any) {
    return (
        <div className={`relative w-40 h-full z-20`}>
            <img src={logo} className='absolute bottom-0 p-3 z-40'/>
            <div className='absolute bottom-0 bg-slate-300 rounded-full w-40 h-40 z-20'/>
        </div>
    );
}